import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PublicSharedModule } from '../../../public/shared/modules/public-shared.module';
import { OverlayPage } from './overlay.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
    , PublicSharedModule
  ],
  declarations: [OverlayPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OverlayPageModule { }
